import { registerMockHandler } from "./mock-handlers";

interface DraftReplyRequest {
  emailSubject?: string;
  emailBody?: string;
  senderName?: string;
  senderEmail?: string;
}

registerMockHandler("POST", "/api/draft-reply", async (body: unknown) => {
  const req = body as DraftReplyRequest;

  // Simulate API latency
  await new Promise((resolve) => setTimeout(resolve, 1500));

  const senderDisplay = req.senderName || req.senderEmail || "there";
  const subject = req.emailSubject || "your email";

  return {
    draft: `Dear ${senderDisplay},\n\nThank you for your email regarding "${subject}". I have reviewed the contents and would like to follow up on the key points raised.\n\nI will get back to you with a more detailed response shortly.\n\nBest regards`,
  };
});
